import { useTranslation } from "react-i18next";
import { Box, Flex } from "@chakra-ui/react";
import time from "src/utils/time";
import { Caption, Subtitle } from "src/atoms/typography";

export default function EndEvent({
  startTimeColumnWidth,
  startDate,
  duration
}) {
  const { t } = useTranslation();
  const startofMonitoring = new Date(startDate);
  const endOfMonitoring = new Date(startofMonitoring.getTime() + duration);
  return (
    <Flex alignItems="center" mt="10px">
      <Caption
        textAlign="right"
        mr="20px"
        color="mediumEmphasis"
        width={startTimeColumnWidth + "px"}
      >
        {time(endOfMonitoring).format("LT")}
      </Caption>
      <Box mr="20px" p="6px" bg="outline" borderRadius="100%" />
      <Subtitle color="highEmphasis">{t("monitoringEnded")}</Subtitle>
    </Flex>
  );
}
